export const read = (lunaClient) => (face) => {
  return {
    ...face,
    uiAvatarURL: lunaClient.faces.getAvatarURL(face.avatar),
  };
};
